import HttpClient from '../../HttpClient/NewApi';

export default {
    edit(cardId, editCardRequest) {
        return HttpClient.patch(`/api/v1/cards/${cardId}`, {
            client: editCardRequest
        });
    }
}

export class EditCardRequest
{
    constructor(
        type,
        name,
        email,
        address,
        lat,
        lng,
        geoId,
        sowingArea,
        assigneeId,
        shouldCallAt,
        callTheme,
        additionalCallInfo,
        hasContract,
        worksWithNds,
        websites,
        filials,
        categories,
        contacts,
        cultures,
        calledAt,
    ) {
        this.type = type;
        this.name = name;
        this.email = email;
        this.lat = lat;
        this.lon = lng;
        this.address = address;
        this.geo_id = geoId;
        this.area_full = sowingArea
        this.date_will_call = shouldCallAt;
        this.call_aim = callTheme;
        this.additional_info = additionalCallInfo;
        this.assignee_id = assigneeId;
        this.contract = hasContract;
        this.vat = worksWithNds;
        this.websites = websites;
        this.filials = filials;
        this.categories = categories;
        this.contacts = contacts;
        this.cultures = cultures
        this.called_at = calledAt;
    }
}

export class Contact
{
    constructor(
        name,
        phone,
        email,
        isVisible,
    ) {
        this.name = name;
        this.phone = phone;
        this.email = email;
        this.isVisible = isVisible;
    }
}

export class GrainVolume
{
    constructor(
        grainId,
        price,
        volume,
        comment,
        id,
    ) {
        this.culture_id = grainId;
        this.price = price;
        this.volume = volume;
        this.area = 0;
        this.quality_comment = comment;
        this.id = id;
    }
}



// WEBPACK FOOTER //
// ./apiClient/Card/Edit/index.js